var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryCache } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
import { TICKET_REMINDERS_API } from 'src/Utils';
import { showErrorToast, showSuccessToast } from 'src/Utils/toastHelper';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from 'src/Utils/toastMessages';
export var useTicketRemindersCols = function () {
    var history = useHistory();
    var queryCache = useQueryCache();
    var _a = useState(null), ticketReminderIdToDelete = _a[0], setTicketReminderIdToDelete = _a[1];
    var _b = useState(false), isDeleteModalOpen = _b[0], setIsDeleteModalOpen = _b[1];
    var deleteTicketReminder = useMutation(function () { return ticketsService.deleteTicketReminder(ticketReminderIdToDelete); }, {
        onSuccess: function () {
            showSuccessToast(SUCCESS_MESSAGES.ticketReminders.deleted);
            queryCache.invalidateQueries([TICKET_REMINDERS_API]);
        },
        onError: function (error) {
            showErrorToast(error, ERROR_MESSAGES.ticketReminders.delete);
        },
    })[0];
    var handleDelete = function () {
        if (ticketReminderIdToDelete) {
            deleteTicketReminder();
        }
        setIsDeleteModalOpen(false);
    };
    var columns = useMemo(function () { return [
        {
            label: '#Ticket',
            render: function (ticketReminder) { return ticketReminder.ticket_number; },
        },
        {
            label: 'Título',
            render: function (ticketReminder) { return ticketReminder.ticket_title; },
        },
        {
            label: 'Edificio',
            render: function (ticketReminder) { var _a, _b; return (_b = (_a = ticketReminder.building) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '-'; },
        },
        {
            label: 'Se notificará',
            render: function (ticketReminder) {
                if (dayjs(ticketReminder.date).isAfter(dayjs())) {
                    return dayjs(ticketReminder.date).set('hour', 9).fromNow();
                }
                else if (ticketReminder.notified_at) {
                    return '-';
                }
                return dayjs().add(1, 'day').set('hour', 9).fromNow();
            },
        },
        {
            label: 'Se notificó',
            render: function (ticketReminder) {
                return ticketReminder.notified_at
                    ? dayjs(ticketReminder.notified_at).fromNow()
                    : '-';
            },
        },
        {
            label: 'Destinatario',
            render: function (ticketReminder) {
                return ticketReminder.recipient.first_name + " " + ticketReminder.recipient.last_name;
            },
        },
    ]; }, []);
    var rowActions = useMemo(function () { return [
        {
            label: 'Editar',
            value: 'edit',
            handler: function (ticketReminder) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    history.push("/recordatorios_de_tickets/" + ticketReminder.id + "/editar");
                    return [2 /*return*/];
                });
            }); },
        },
        {
            label: 'Eliminar',
            value: 'delete',
            handler: function (ticketReminder) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setTicketReminderIdToDelete(ticketReminder.id);
                    setIsDeleteModalOpen(true);
                    return [2 /*return*/];
                });
            }); },
        },
    ]; }, []);
    return {
        rowActions: rowActions,
        columns: columns,
        handleDelete: handleDelete,
        isDeleteModalOpen: isDeleteModalOpen,
        setIsDeleteModalOpen: setIsDeleteModalOpen,
    };
};
